import { render, staticRenderFns } from "./AdvertisementGeneralDetails.vue?vue&type=template&id=26d632ee&"
import script from "./AdvertisementGeneralDetails.vue?vue&type=script&lang=js&"
export * from "./AdvertisementGeneralDetails.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisementGeneralDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports